// --- Config -------------------------------------------------------------
const RUNTIME_ORIGIN = window.__ENV?.API_ORIGIN;          // 來自 /env.js（部署時）
const BUILD_ORIGIN = process.env.REACT_APP_API_ORIGIN;    // 來自 CRA build 時
const API_ORIGIN = RUNTIME_ORIGIN || BUILD_ORIGIN;

// 需要自動改寫的舊網址前綴（可自行加）
const LEGACY_BASES = ['http://localhost:5000', 'http://127.0.0.1:5000'];
// const LEGACY_BASES = [];

// 取得 JWT 的方式（可依你的狀態管理調整）
function getToken() {
  try {
    // console.log("flaskAccessToken:", sessionStorage.getItem("flaskAccessToken"));

    return sessionStorage.getItem('flaskAccessToken') || localStorage.getItem('token');
  } catch {
    return null;
  }
}

// 是否輸出 debug 訊息
const DEBUG = false;
// -----------------------------------------------------------------------

// 先保留原生 fetch，避免遞迴
const origFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  let url;
  let reqInit = { ...init };

  if (typeof input === 'string') {
    url = input;
  } else {
    // input 可能是 Request 物件，取出原參數
    url = input.url;
    reqInit = {
      ...reqInit,
      method: input.method,
      headers: new Headers(input.headers),
      body: input.body,
    };
    // reqInit = {
    //   method: input.method,
    //   headers: new Headers(input.headers),
    //   body: input.body,
    //   mode: input.mode,
    //   credentials: input.credentials,
    //   cache: input.cache,
    //   redirect: input.redirect,
    //   referrer: input.referrer,
    //   referrerPolicy: input.referrerPolicy,
    //   integrity: input.integrity,
    //   keepalive: input.keepalive,
    //   signal: input.signal,
    // };
  }

  // 若是舊 base 且已有 API_ORIGIN，就改寫成新網域
  if (API_ORIGIN && LEGACY_BASES.some(b => url.startsWith(b))) {
    url = API_ORIGIN + url.replace(/^https?:\/\/(localhost|127\.0\.0\.1):5000/, '');
  }

  // 自動加 Authorization（呼叫者沒自己帶時）
  const headers = new Headers(reqInit.headers || {});
  if (!headers.has('Authorization')) {
    const token = getToken();
    if (token) headers.set('Authorization', `Bearer ${token}`);
  }
  reqInit.headers = headers;
  // console.log("AUTH header =", headers.get("Authorization"));
  // console.log("ALL headers =", Array.from(headers.entries()));


  if (DEBUG) console.debug('[fetch-shim]', { url, reqInit });

  // 回呼原生 fetch
  if (typeof input === 'string') {
    // console.log("reqInit:", reqInit);

    return origFetch(url, reqInit);
  }
  console.log("fetch url:", url)
  return origFetch(new Request(url, reqInit));
};
